module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAuCAMAAABzsJvxAAAANlBMVEUAAAA0u0c4xFA3w085xFE4xFE4xFA3wk45w1A4xFA3w1A4w1A5wU81vE04xFA3xE84w1A5xFFtDBZbAAAAEXRSTlMAD7he4PLAWMbsU4MtGt+BgDswF/MAAACQSURBVDjL7ZU5EgMhDASFOPey3f//rBO2VlC41o6c0BmoS8pm5CTrQs+iWRqcMkad1RSCd9LifAA1HyukKrVigmyXhWqVeqxUL9h1ES9DTTzx0sDJGAdWk09MbWpTm9o/tWM9vtD2SNztaByDG7DZGOxCteKhecU+oiuv8ryWPdCfA/++Pu7LqCGnQbWl8+Ib3rcTC1us8c0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/phone-icon.png
// module id = 581
// module chunks = 0